class CartDrawerOutland extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById("cart-drawer-outland");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.boundHandleEsc = this.handleEsc.bind(this);
    this.focusTrapHandler = null;

    this.debouncedUpdateCartNote = debounce((event) => {
      this.updateCartNote(event.target.value);
    }, 300);

    document.addEventListener(
      "click",
      (e) => {
        if (!e.target.closest("#cart-drawer-outland")) {
          const trigger = e.target.closest('button, [role="button"], a[href]') || e.target;
          this.pendingTrigger = trigger;

          const productBlock = trigger.closest('[class*="product-id-"]');
          const productIdMatch = productBlock?.className.match(/\bproduct-id-\S+\b/);
          this.pendingTriggerProductId = productIdMatch ? productIdMatch[0] : null;
        }
      },
      true
    );

    document.addEventListener("click", (e) => {
      const button = document.querySelector("#cart-drawer-outland .cart-close");
      if (e.target == button) {
        this.close.call(this);
      }
    });

    document.addEventListener("change", (e) => {
      if (e.target.classList.contains("cart-drawer-quantity-input")) {
        this.onChange(e);
      }
    });

    document.addEventListener("click", (e) => {
      const button = document.querySelector("#cart-drawer-outland .cart-drawer-gift-wrap button");

      if (e.target == button) {
        e.preventDefault();
        this.addItem(button.dataset.variantId, { _gift_wrap: true });
      }
    });

    document.addEventListener("click", (e) => {
      const button = document.querySelector("#gift_wrap_remove");

      if (e.target == button) {
        e.preventDefault();
        this.updateQuantity(button.dataset.line, 0).then(() => this.updateCartNote(""));
      }
    });

    document.addEventListener("keyup", (e) => {
      const giftNote = document.getElementById("gift_wrap_note");

      if (e.target == giftNote) {
        this.debouncedUpdateCartNote(e);
      }
    });

    document.addEventListener("click", (e) => {
      const buttons = document.querySelectorAll(".cart-drawer-upsell-item-add");

      buttons.forEach((button) => {
        if (e.target == button) {
          e.preventDefault();
          const parent = e.target.closest(".cart-drawer-upsell-action");
          this.addItem(parent.querySelector("select").value);
        }
      });
    });

    document.addEventListener("click", (e) => {
      const buttons = document.querySelectorAll(".cart-drawer-item-remove");

      buttons.forEach((button) => {
        if (e.target !== button) return;

        e.preventDefault;
        this.updateQuantity(button.dataset.index, 0);
      });
    });

    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("close-cart-upsells")) {
        const slideshow = e.target.closest(".slider-cart-drawer-upsell");
        slideshow.parentNode.removeChild(slideshow);
      }
    });

    // Listens for confirmed item additions from any Rebuy module (including Bundle Builder)
    document.addEventListener("rebuy:cart.add", (event) => {
      const updatedCart = event?.detail?.cart || event?.detail;
      this.refresh();
    });

    document.addEventListener("rebuy:cart.change", () => {
      if (!this.drawer.classList.contains("active")) return;
      fetch(`/cart?section_id=cart-drawer-outland`)
        .then((response) => response.text())
        .then((state) => {
          document.getElementById("cart-drawer-outland").innerHTML = this.getSectionInnerHTML(
            state,
            "#cart-drawer-outland"
          );
          this.updateCartCountBubble();
        })
        .catch(console.error);
    });
  }

  open() {
    this.returnFocus = this.returnFocus || this.pendingTrigger || document.activeElement;
    this.returnFocusProductId = this.returnFocusProductId || this.pendingTriggerProductId || null;
    this.drawer.classList.add("animate", "active");
    document.querySelector("body").classList.add("modal-open");
    document.removeEventListener('keydown', this.boundHandleEsc);
    document.addEventListener('keydown', this.boundHandleEsc);

    this.drawer.addEventListener(
      "transitionend",
      () => {
        this.drawer.querySelector('.cart-close').focus();
      },
      { once: true }
    );

    if (!this.focusTrapHandler) {
      this.focusTrapHandler = (e) => {
        if (!this.drawer.contains(e.target)) {
          this.drawer.querySelector('.cart-close').focus();
        }
      };
      document.addEventListener('focusin', this.focusTrapHandler);
    }

    setTimeout(() => {
      document.body.addEventListener("click", this.onBodyClick);
    }, 0);

    const upsells = document.querySelector("slider-component.slider-cart-drawer-upsell");
    if (upsells) {
      upsells.initPages();
    }
  }

  handleEsc(e) {
    if(e.key === 'Escape') {
      this.close();
    }
  }

  close() {
    this.drawer.classList.remove("active");
    document.querySelector("body").classList.remove("modal-open");
    document.body.removeEventListener("click", this.onBodyClick);
    document.removeEventListener('keydown', this.boundHandleEsc);
    if (this.focusTrapHandler) {
      document.removeEventListener('focusin', this.focusTrapHandler);
      this.focusTrapHandler = null;
    }
    let target = this.returnFocus?.isConnected ? this.returnFocus : null;

    if (!target && this.returnFocusProductId) {
      const productBlock = document.querySelector(`.${CSS.escape(this.returnFocusProductId)}`);
      target = productBlock?.querySelector("button, [role='button'], a[href]") || null;
    }

    removeTrapFocus(target);

    if (document.activeElement !== target) {
      document.querySelector('#cart-icon-bubble')?.focus();
    }

    this.returnFocus = null;
    this.returnFocusProductId = null;
    this.pendingTrigger = null;
    this.pendingTriggerProductId = null;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.drawer && !target.closest("#cart-drawer-outland")) {
      this.close();
    }
  }

  enableLoading() {
    this.drawer.classList.add("loading");
  }

  disableLoading() {
    this.drawer.classList.remove("loading");
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateQuantity(line, quantity) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: ["cart-drawer-outland"],
      sections_url: window.location.pathname,
    });

    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        this.renderContents(state);
        this.disableLoading();
      })
      .catch((e) => {
        this.disableLoading();
      });
    // affirm.ui.refresh();
  }

  addItem(variantId, properties) {
    this.enableLoading();

    let item = {
      quantity: 1,
      id: variantId,
    };

    if (properties) item.properties = properties;

    const body = JSON.stringify({
      items: [item],
      sections: ["cart-drawer-outland"],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((state) => {
        this.renderContents(state);
      })
      .catch(console.error)
      .finally(() => {
        this.disableLoading();
      });
  }

  refresh(cart) {
    this.enableLoading();

    fetch(`/cart?section_id=cart-drawer-outland`)
      .then((response) => response.text())
      .then((state) => {
        this.renderContentsRebuy(state);
      })
      .catch(console.error)
      .finally(() => {
        this.disableLoading();
      });
  }

  updateCartNote(note) {
    const body = JSON.stringify({ note });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    document.getElementById("cart-drawer-outland").innerHTML = this.getSectionInnerHTML(
      parsedState.sections["cart-drawer-outland"],
      "#cart-drawer-outland"
    );
    if(window.Rebuy){ Rebuy.init(); } //Initialize Rebuy widget, required when cart transitions from empty
    // affirm.ui.refresh();
    this.updateCartCountBubble();
    this.open();

    if(parsedState.key) {
      this.focusAddedItem(parsedState.key)
    }
  }

  focusAddedItem(key) {
    let lineItem = this.querySelector(`[data-line-item-key="${key}"]`),
        title = lineItem?.querySelector('[data-line-item-title]');

    title ? title.focus() : this.querySelector('.cart-close')?.focus();
  }

  renderContentsRebuy(parsedState) {
    this.productId = parsedState.id;
    document.getElementById("cart-drawer-outland").innerHTML = this.getSectionInnerHTML(
      parsedState,
      "#cart-drawer-outland"
    );
    if(window.Rebuy){ Rebuy.init(); } //Initialize Rebuy widget, required when cart transitions from empty
    // affirm.ui.refresh();
    this.updateCartCountBubble();
    this.open();
  }

  updateCartCountBubble() {
    fetch(`${routes.cart_url}`, { ...fetchGetConfig() })
      .then((response) => response.json())
      .then((cart) => {
        document.querySelector(".cart-count-bubble").innerHTML = cart.item_count || "";
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
}

customElements.define("cart-drawer-outland", CartDrawerOutland);
